export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-da.b3fee7c2.svg";